<div class="review-header">
  <h1 class="ds-heading-1">{{'GROW.project.investmentFlow.step2.heading' | translate}}</h1>
  <p class="ds-running-1" [innerHTML]="'GROW.project.investmentFlow.step2.body' | translate"></p>
</div>
<div class="review-box" [class.has-error]="submitted && !agreements[agreementTypes.DOCUMENTS]">
  <h2 class="ds-heading-2">{{'GROW.project.investmentFlow.step2.documents' | translate}}</h2>
  <div *ngIf="hasDocuments" class="ds-rows-white">
    <div *ngFor="let document of project.investment_documents" class="ds-row-white">
      <div class="content">
        <a (click)="openDocPDF(document.url, document.title)">
          <app-ds-icon name="file-text"></app-ds-icon>
          <span class="ds-ui-2">{{ document.title }}</span>
        </a>
      </div>
    </div>
  </div>
  <div class="ds-form-row">
    <app-ds-checkbox
      [checkboxPosition]="'top'"
      [label]="'GROW.project.investmentFlow.step2.documentsConsent' | translate"
      [checked]="agreements[agreementTypes.DOCUMENTS]"
      (clicked)="onAccept(agreementTypes.DOCUMENTS)"
      [hasError]="submitted && !agreements[agreementTypes.DOCUMENTS]"
      [errorMessage]="'GROW.project.investmentFlow.step2.missingConsentError' | translate"
    ></app-ds-checkbox>
  </div>
</div>

<div class="review-box" [class.has-error]="submitted && !agreements[agreementTypes.GENERAL]">
  <h2 class="ds-heading-2">{{'GROW.project.investmentFlow.step2.generalAgreements' | translate}}</h2>

  <div *ngIf="project.general_agreements_details !== null" [innerHTML]="project.general_agreements_details" class="review-general"></div>

  <div class="ds-form-row" [class.has-error]="submitted && !agreements[agreementTypes.GENERAL]">
    <app-ds-checkbox
      [checkboxPosition]="'top'"
      [label]="'GROW.project.investmentFlow.step2.generalAgreementsConsent' | translate"
      [checked]="agreements[agreementTypes.GENERAL]"
      (clicked)="onAccept(agreementTypes.GENERAL)"
      [hasError]="submitted && !agreements[agreementTypes.GENERAL]"
      [errorMessage]="'GROW.project.investmentFlow.step2.missingConsentError' | translate"
    ></app-ds-checkbox>
  </div>
</div>

<div class="review-box" [class.has-error]="submitted && !agreements[agreementTypes.WAIVER]">
  <h2 class="ds-heading-2">{{'GROW.project.investmentFlow.step2.waiverTitle' | translate}}</h2>

  <div class="waiver">
    <p class="ds-ui-3 ds-color-core-neutral-8" [innerHTML]="'GROW.project.investmentFlow.step2.waiver.content' | translate"></p>
  </div>
  <div class="ds-form-row">
    <app-ds-checkbox
      [checkboxPosition]="'top'"
      [label]="'GROW.project.investmentFlow.step2.waiverConsent' | translate"
      [checked]="agreements[agreementTypes.WAIVER]"
      [hasError]="submitted && !agreements[agreementTypes.WAIVER]"
      [errorMessage]="'GROW.project.investmentFlow.step2.missingConsentError' | translate"
      (clicked)="onAccept(agreementTypes.WAIVER)"
    ></app-ds-checkbox>
  </div>
</div>
<app-ds-button (clicked)="onSubmit()" [isLoading]="loading">
  {{'GROW.project.investmentFlow.step2.buttonLabel' | translate: {amount: selectedAmount | thousand: project.currency } }}
</app-ds-button>
